import React, { useState, useEffect } from 'react';
import { submitTestimony } from '../firebase/firestoreService';
import { Link } from 'react-router-dom';

const COURSES = ['SSC', 'CBSE', 'Science / JEE', 'NEET', 'MH-CET', 'Commerce', 'Other'];

const WriteTestimony = () => {
  const [form, setForm] = useState({ name: '', batch: '', course: '', message: '' });
  const [status, setStatus] = useState('');

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('loading');
    try {
      await submitTestimony(form);
      setStatus('success');
      setForm({ name: '', batch: '', course: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <>
      <div className="ngt-page-banner">
        <h1>Share Your Story</h1>
        <p>Your experience can inspire future students. We'd love to hear from you.</p>
      </div>
      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item"><Link to="/testimony">Testimonials</Link></li>
          <li className="breadcrumb-item active">Write a Testimonial</li>
        </ol>
      </nav>
      <section style={{ padding: '4rem 0' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="ngt-enquiry-form-wrap">
                <h2 className="section-title text-start mb-4" style={{ textAlign: 'left' }}>Write a Testimonial</h2>
                {status === 'success' && (
                  <div className="ngt-alert-success mb-4">
                    <i className="fas fa-check-circle me-2"></i>
                    Thank you for sharing your experience! Your testimonial is pending review and will be published shortly.
                  </div>
                )}
                {status === 'error' && (
                  <div className="ngt-alert-error mb-4">
                    <i className="fas fa-exclamation-circle me-2"></i>
                    Something went wrong. Please try again.
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="ngt-label" htmlFor="t-name">Full Name *</label>
                      <input id="t-name" name="name" type="text" className="ngt-form-control"
                        placeholder="Your name" value={form.name} onChange={handleChange} required />
                    </div>
                    <div className="col-md-3">
                      <label className="ngt-label" htmlFor="t-batch">Batch Year</label>
                      <input id="t-batch" name="batch" type="number" className="ngt-form-control"
                        placeholder="e.g. 2024" min="2000" max="2030" value={form.batch} onChange={handleChange} />
                    </div>
                    <div className="col-md-3">
                      <label className="ngt-label" htmlFor="t-course">Course *</label>
                      <select id="t-course" name="course" className="ngt-form-control"
                        value={form.course} onChange={handleChange} required>
                        <option value="">— Select —</option>
                        {COURSES.map(c => <option key={c}>{c}</option>)}
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="ngt-label" htmlFor="t-message">Your Testimonial *</label>
                      <textarea id="t-message" name="message" rows="6" className="ngt-form-control"
                        placeholder="Share your experience at NGT — what you learned, how the faculty helped, and how NGT shaped your academic journey..."
                        value={form.message} onChange={handleChange} required minLength={50}></textarea>
                      <small style={{ color: 'var(--ngt-grey)' }}>Minimum 50 characters. Testimonials are reviewed before publishing.</small>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="btn-ngt-primary w-100" style={{ padding: '13px', fontSize: '1rem' }}
                        disabled={status === 'loading'}>
                        {status === 'loading'
                          ? <><i className="fas fa-spinner fa-spin me-2"></i>Submitting…</>
                          : <><i className="fas fa-paper-plane me-2"></i>Submit Testimonial</>}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WriteTestimony;
